import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "12", cy: "17", r: "1", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 7v6h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 17a9 9 0 0 1 9-9 9 9 0 0 1 6 2.3l3 2.7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RedoDot";
const RedoDot = memo(themed(Icon));
export {
  RedoDot
};
//# sourceMappingURL=redo-dot.js.map
